exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-item__tip[data-v-b94b9f9c]{font-style:italic;opacity:.8;display:inline-block;float:right;margin-right:1rem;font-weight:600;color:#f67e22}.collapse-item__tip[data-v-b94b9f9c]:hover{opacity:1}.alignR[data-v-b94b9f9c]{text-align:right}.drawer .el-collapse-item__header[data-v-b94b9f9c],.drawer .el-collapse-item__wrap[data-v-b94b9f9c]{background-color:#fafafa}.new-request__search-cont[data-v-b94b9f9c]{padding:0 0 30px}.new-request__search[data-v-b94b9f9c]{width:100%}.buttons-section[data-v-b94b9f9c]{margin-bottom:20px;text-align:center}.make-payment_date[data-v-b94b9f9c]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b94b9f9c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/MakePayment.vue
// module id = 517
// module chunks = 0